<template>
  <div class="modal" v-if="showModal">
    <div class="wrapper">
      <font-awesome-icon icon="fa-xmark" class="exit" @click.stop.prevent="closed" />
      <label>Logo: </label>
      <span class="file"><input class="dropzone" type="file" id="file" name="file" @change="handleFileSelect" multiple accept=".jpg, .jpeg, .png"/></span>
      <span class="invert"><input type="checkbox" v-model="invertFromDatabase" @click="invertImage" /> Invert logo for dark mode</span>
      <!-- make this specific to rectangle -->
      <div class="images">
        <div class="unit">
          <div class="title">
            <p>Preview:</p>
            <div class="theme">
              <Theme />
            </div>
          </div>
          <canvas id="preview" class="logo"></canvas>
        </div>
        <div class="unit">
          <p>Current Logo:</p>
          <img :src="getLogoViaSite(site)" class="saved logo" />
        </div>
      </div>
      <button class="button is-primary action-colour" @click.stop.prevent="saveLogo">Save</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"; // Import Vuex for state management
import { Theme } from "@monolith/components";

export default {
  name: "ImageUploadModal",
  components: {
    Theme,
  },
  data() {
    return {
      selectedFile: null,
      newLogo: "", // Variable to hold the new logo image
      site: this.$route.params.site, // Get the site from the route parameters
      inverted: false, // Initialize inverted state
      invertFromDatabase: false, // Variable to hold the inverted state from the database
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
async mounted() {
  const webSettings = await this.webSettingsViaSite(this.site);
  if (webSettings && webSettings.logo && typeof webSettings.logo.invert === "boolean") {
    this.invertFromDatabase = webSettings.logo.invert;
    this.inverted = webSettings.logo.invert; // make sure preview matches too
  }
},

  computed: {
    ...mapGetters({
      companyName: "companyName",
      companySettings: "companySettings",
      siteSettings: "siteSettings",
      webSettingsViaSite: "webSettingsViaSite",
      channels: "channels",
      getLogoViaSite: "getLogoViaSite",
    }),
  },
  methods: {
    closed() {
      this.$emit("closeImgModal"); // Emit an event to close the modal
    },
    getInverted(){
      if (this.settings && this.settings.logo) {
        return this.settings.logo.invert || false; // Get the inverted state from the site settings
      }
      // return this.webSettingsViaSite.logo.invert || false; // Get the inverted state from the web settings
    },
    invertImage() {
      let preview = document.getElementById("preview");
      this.inverted = !this.inverted;
      if (this.inverted) {
        preview.style.filter = "invert(1)";
      } else {
        preview.style.filter = "invert(0)";
      }
    },
    saveLogo() {
      this.$emit("saveLogo", { logo: this.newLogo, invert: this.inverted }); // Emit an event to save the logo
      this.closed(); // Close the modal
    },

    handleFileSelect(event) {
      let newImageUrl = "";
      let imgFile = event.target.files[0]; // how do we get this if only one file?

      var intendedHeight = 200;

      var reader = new FileReader(); // Create a new FileReader object
      reader.readAsDataURL(imgFile); // Read the file as a data URL

      reader.onload = (e) => {
        let img = document.createElement("img"); // Create a new image element
        img.src = e.target.result; // Set the image source to the data URL

        img.onload = () => {
          var canvas = document.getElementById("preview");

          let scaleFactor = intendedHeight / img.height;

          canvas.width = img.width * scaleFactor; // Set the canvas width to the image width
          canvas.height = intendedHeight; // Set the canvas height to the image height

          // get the scale
          // it is the min of the 2 ratios
          // let scaleFactor = Math.max(intendedWidth / img.width, intendedHeight / img.height);

          // Finding the new width and height based on the scale factor
          let newWidth = img.width * scaleFactor;
          let newHeight = img.height * scaleFactor;

          // get the top left position of the image
          // in order to center the image within the canvas
          let x = canvas.width / 2 - newWidth / 2;
          let y = canvas.height / 2 - newHeight / 2;
          var ctx = canvas.getContext("2d");

          // When drawing the image, we have to scale down the image
          // width and height in order to fit within the canvas
          ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
          ctx.drawImage(img, x, y, newWidth, newHeight);

          // drawImage( image,
          //   // source image crop and resize
          //   // sx, sy = upper left coordinates of crop location
          //   // sWidth, sHeight = dimensions of crop
          //   sx, sy, sWidth, sHeight,

          //   // placement of image on canvas
          //   // dx, dy = upper left coordinates of placement
          //   // dWidth, dHeight = dimensions of placement on canvas
          //   dx, dy, dWidth, dHeight
          // );

          newImageUrl = ctx.canvas.toDataURL("image/png"); // Convert the canvas to a data URL

          this.newLogo = newImageUrl; // a variable to hold the new image without saving
        };
      };
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.wrapper {
  .file {
    margin: 0.5rem;
  }
  .invert {
    margin: 0.25rem;
  }
  .images {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    .unit {
      .title {
        margin-top: 1rem;
      }

      .logo {
        border: 2px dotted var(--action-colour);
        background-color: var(--secondary-color);
        // width: 15rem;
      }
      .invert {
        filter: invert(1);
      }
    }
  }
}
@media only screen and (orientation: portrait) {
  .wrapper {
    .dropzone {
      width: 100%;
    }

    .images {
      .unit {
        .logo {
          width: 100%;
        }
      }
    }
  }
}
</style>
